import { ModelSelector } from '@/components/nodes/model-selector';

type ModelItemProps = {
  id: string;
  value: string;
  options: Record<string, any>;
  onChange: (value: string) => void;
  disabled?: boolean;
  width?: number | string | 'auto';
};

export function ModelItem({ id, value, options, onChange, disabled, width = 'auto' }: ModelItemProps) {
  return (
    <ModelSelector
      id={id}
      value={value}
      options={options}
      onChange={onChange}
      disabled={disabled}
      width={width}
      className="rounded-md h-9"
    />
  );
}


